import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=1c847c3e"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports